import React, { useState } from "react";
import styled from "styled-components";
import { colors } from "common/const/colors";
import { CalendarCell } from "common/components";
import { isBefore, isAfter } from "common/utils/dateUtil";

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "July",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const MonthYearPicker = ({
  date,
  onSelect,
  onClose,
  minDate,
  maxDate,
}) => {
  const [initialYear] = useState(
    date?.getFullYear() || new Date().getFullYear(),
  );

  const handleMonthSelect = (monthIndex) => {
    const selectedDate = new Date(date?.getFullYear(), monthIndex, 1);
    onSelect?.(selectedDate);
    onClose?.();
  };

  const isMonthDisabled = (monthIndex) => {
    const checkDate = new Date(date?.getFullYear(), monthIndex, 1);

    if (minDate) {
      const min = new Date(minDate);
      const minMonth = new Date(min.getFullYear(), min.getMonth(), 1);
      if (isBefore(checkDate, minMonth)) return true;
    }

    if (maxDate) {
      const max = new Date(maxDate);
      const maxMonth = new Date(max.getFullYear(), max.getMonth(), 1);
      if (isAfter(checkDate, maxMonth)) return true;
    }

    return false;
  };

  const selectedStyle = {
    backgroundColor: colors.withOpacity(colors.MainBlue, 0.1),
    color: colors.MainBlue,
    borderRadius: "0.625rem",
    border: `2px solid ${colors.MainBlue}`,
    fontWeight: "bold",
  };

  const disabledStyle = {
    color: colors.Gray,
  };

  return (
    <Container>
      <MonthGrid>
        {MONTHS.map((month, index) => (
          <CalendarCell
            key={month}
            date={date}
            style={
              isMonthDisabled(index)
                ? disabledStyle
                : date?.getFullYear() === initialYear &&
                    date?.getMonth() === index
                  ? selectedStyle
                  : undefined
            }
            onClick={() => !isMonthDisabled(index) && handleMonthSelect(index)}>
            {month}
          </CalendarCell>
        ))}
      </MonthGrid>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;

  padding: 0.75rem;
  border-radius: 0.5rem;
  border: 1px solid var(--Gray);
`;

const MonthGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-content: space-between;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`;
